'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _reactstrap = require('reactstrap');

var _ApiObjectSuggestField = require('./../field/ApiObjectSuggestField');

var _ApiObjectSuggestField2 = _interopRequireDefault(_ApiObjectSuggestField);

var _obalkyActions = require('./../actions/obalkyActions');

var obalkyActions = _interopRequireWildcard(_obalkyActions);

var _utils = require('./../utils');

var _Utils = require('./../Utils2');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getArea(props) {
    return props.area ? props.area : "shared.adresniStitkySablona";
} /**
   * Field pro výběr šablony typu obálky.
   */

var TypObalkyField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(TypObalkyField, _AbstractReactCompone);

    function TypObalkyField(props) {
        (0, _classCallCheck3.default)(this, TypObalkyField);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TypObalkyField.__proto__ || (0, _getPrototypeOf2.default)(TypObalkyField)).call(this, props));

        _this.handleFilterSuggestions = function (value) {
            var sablony = _this.props.sablony;


            return new _promise2.default(function (resolve, reject) {
                if (sablony.fetched) {
                    var rows = (0, _utils.filterObjectsByPropertyFulltext)(sablony.rows, value, "popis");
                    resolve(rows);
                } else {
                    resolve([]);
                }
            });
        };

        return _this;
    }

    (0, _createClass3.default)(TypObalkyField, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var area = getArea(this.props);
            this.dispatch(obalkyActions.fetchListIfNeeded(area));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                sablony = _props.sablony,
                other = (0, _objectWithoutProperties3.default)(_props, ['sablony']);


            if (!sablony || !sablony.fetched) {
                return _react2.default.createElement(_reactstrap.Input, { type: 'text', disabled: true });
            }

            return _react2.default.createElement(_ApiObjectSuggestField2.default, (0, _extends3.default)({
                dropdown: true,
                filterSuggestions: this.handleFilterSuggestions,
                apiRequestDelay: 0,
                getItemValue: function getItemValue(item) {
                    return item ? item.popis : "";
                },
                renderSuggestion: function renderSuggestion(i, active, getItemValue) {
                    return _react2.default.createElement(
                        'div',
                        {
                            className: active ? "active" : "" },
                        i.popis
                    );
                }
            }, other));
        }
    }]);
    return TypObalkyField;
}(_AbstractReactComponent2.default);

TypObalkyField.PropTypes = {
    sablony: _react2.default.PropTypes.object, // není required kvůli shared store, který nemusí být inicializovaný
    area: _react2.default.PropTypes.string,
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};


function mapStateToProps(state, props) {
    var useArea = getArea(props);

    return {
        sablony: (0, _utils.storeFromArea)(state, useArea, false)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TypObalkyField);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvVHlwT2JhbGt5RmllbGQuanN4Il0sIm5hbWVzIjpbIm9iYWxreUFjdGlvbnMiLCJnZXRBcmVhIiwicHJvcHMiLCJhcmVhIiwiVHlwT2JhbGt5RmllbGQiLCJoYW5kbGVGaWx0ZXJTdWdnZXN0aW9ucyIsInZhbHVlIiwic2FibG9ueSIsInJlc29sdmUiLCJyZWplY3QiLCJmZXRjaGVkIiwicm93cyIsImRpc3BhdGNoIiwiZmV0Y2hMaXN0SWZOZWVkZWQiLCJvdGhlciIsIml0ZW0iLCJwb3BpcyIsImkiLCJhY3RpdmUiLCJnZXRJdGVtVmFsdWUiLCJBYnN0cmFjdFJlYWN0Q29tcG9uZW50IiwiUHJvcFR5cGVzIiwiUmVhY3QiLCJvYmplY3QiLCJzdHJpbmciLCJhZGRvbnNCZWZvcmUiLCJDT01QT05FTlRfQ0hJTERSRU4iLCJhZGRvbnNBZnRlciIsIm1hcFN0YXRlVG9Qcm9wcyIsInN0YXRlIiwidXNlQXJlYSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFHQTs7OztBQUNBOztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7QUFDQTs7SUFBWUEsYTs7QUFDWjs7QUFDQTs7Ozs7O0FBR0EsU0FBU0MsT0FBVCxDQUFpQkMsS0FBakIsRUFBd0I7QUFDcEIsV0FBT0EsTUFBTUMsSUFBTixHQUFhRCxNQUFNQyxJQUFuQixHQUEwQiw2QkFBakM7QUFDSCxDLENBZkQ7Ozs7SUFpQk1DLGM7OztBQUVGLDRCQUFZRixLQUFaLEVBQW1CO0FBQUE7O0FBQUEsMEpBQ1RBLEtBRFM7O0FBQUEsY0FnQm5CRyx1QkFoQm1CLEdBZ0JPLFVBQUNDLEtBQUQsRUFBVztBQUFBLGdCQUMxQkMsT0FEMEIsR0FDZixNQUFLTCxLQURVLENBQzFCSyxPQUQwQjs7O0FBR2pDLG1CQUFPLHNCQUFZLFVBQUNDLE9BQUQsRUFBVUMsTUFBVixFQUFxQjtBQUNwQyxvQkFBSUYsUUFBUUcsT0FBWixFQUFxQjtBQUNqQix3QkFBTUMsT0FBTyw0Q0FBZ0NKLFFBQVFJLElBQXhDLEVBQThDTCxLQUE5QyxFQUFxRCxPQUFyRCxDQUFiO0FBQ0FFLDRCQUFRRyxJQUFSO0FBQ0gsaUJBSEQsTUFHTztBQUNISCw0QkFBUSxFQUFSO0FBQ0g7QUFDSixhQVBNLENBQVA7QUFRSCxTQTNCa0I7O0FBQUE7QUFFbEI7Ozs7NkNBRW9CO0FBQ2pCLGdCQUFNTCxPQUFPRixRQUFRLEtBQUtDLEtBQWIsQ0FBYjtBQUNBLGlCQUFLVSxRQUFMLENBQWNaLGNBQWNhLGlCQUFkLENBQWdDVixJQUFoQyxDQUFkO0FBQ0g7OztpQ0FzQlE7QUFBQSx5QkFDdUIsS0FBS0QsS0FENUI7QUFBQSxnQkFDRUssT0FERixVQUNFQSxPQURGO0FBQUEsZ0JBQ2NPLEtBRGQ7OztBQUdMLGdCQUFJLENBQUNQLE9BQUQsSUFBWSxDQUFDQSxRQUFRRyxPQUF6QixFQUFrQztBQUM5Qix1QkFDSSw4QkFBQyxpQkFBRCxJQUFPLE1BQUssTUFBWixFQUFtQixVQUFVLElBQTdCLEdBREo7QUFHSDs7QUFFRCxtQkFDSSw4QkFBQywrQkFBRDtBQUNJLDBCQUFVLElBRGQ7QUFFSSxtQ0FBbUIsS0FBS0wsdUJBRjVCO0FBR0ksaUNBQWlCLENBSHJCO0FBSUksOEJBQWMsc0JBQUNVLElBQUQ7QUFBQSwyQkFBVUEsT0FBT0EsS0FBS0MsS0FBWixHQUFvQixFQUE5QjtBQUFBLGlCQUpsQjtBQUtJLGtDQUFrQiwwQkFBQ0MsQ0FBRCxFQUFJQyxNQUFKLEVBQVlDLFlBQVo7QUFBQSwyQkFBNkI7QUFBQTtBQUFBO0FBQzNDLHVDQUFXRCxTQUFTLFFBQVQsR0FBb0IsRUFEWTtBQUNQRCwwQkFBRUQ7QUFESyxxQkFBN0I7QUFBQTtBQUx0QixlQU9RRixLQVBSLEVBREo7QUFXSDs7O0VBbkR3Qk0sZ0M7O0FBQXZCaEIsYyxDQVdLaUIsUyxHQUFZO0FBQ2ZkLGFBQVNlLGdCQUFNRCxTQUFOLENBQWdCRSxNQURWLEVBQ2tCO0FBQ2pDcEIsVUFBTW1CLGdCQUFNRCxTQUFOLENBQWdCRyxNQUZQO0FBR2ZDLGtCQUFjQyx5QkFIQztBQUlmQyxpQkFBYUQ7QUFKRSxDOzs7QUEyQ3ZCLFNBQVNFLGVBQVQsQ0FBeUJDLEtBQXpCLEVBQWdDM0IsS0FBaEMsRUFBdUM7QUFDbkMsUUFBTTRCLFVBQVU3QixRQUFRQyxLQUFSLENBQWhCOztBQUVBLFdBQU87QUFDSEssaUJBQVMsMEJBQWNzQixLQUFkLEVBQXFCQyxPQUFyQixFQUE4QixLQUE5QjtBQUROLEtBQVA7QUFHSDs7a0JBRWMseUJBQVFGLGVBQVIsRUFBeUJ4QixjQUF6QixDIiwiZmlsZSI6IlR5cE9iYWxreUZpZWxkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBGaWVsZCBwcm8gdsO9YsSbciDFoWFibG9ueSB0eXB1IG9iw6Fsa3kuXG4gKi9cbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQge2Nvbm5lY3R9IGZyb20gJ3JlYWN0LXJlZHV4J1xuaW1wb3J0IEFic3RyYWN0UmVhY3RDb21wb25lbnQgZnJvbSAnLi8uLi9BYnN0cmFjdFJlYWN0Q29tcG9uZW50JztcbmltcG9ydCB7SW5wdXR9IGZyb20gJ3JlYWN0c3RyYXAnO1xuaW1wb3J0IEFwaU9iamVjdFN1Z2dlc3RGaWVsZCBmcm9tICcuLy4uL2ZpZWxkL0FwaU9iamVjdFN1Z2dlc3RGaWVsZCc7XG5pbXBvcnQgKiBhcyBvYmFsa3lBY3Rpb25zIGZyb20gXCIuLy4uL2FjdGlvbnMvb2JhbGt5QWN0aW9uc1wiO1xuaW1wb3J0IHtmaWx0ZXJPYmplY3RzQnlQcm9wZXJ0eUZ1bGx0ZXh0fSBmcm9tIFwiLi8uLi91dGlsc1wiO1xuaW1wb3J0IHtDT01QT05FTlRfQ0hJTERSRU59IGZyb20gJy4vLi4vVXRpbHMyJztcbmltcG9ydCB7c3RvcmVGcm9tQXJlYX0gZnJvbSBcIi4vLi4vdXRpbHNcIjtcblxuZnVuY3Rpb24gZ2V0QXJlYShwcm9wcykge1xuICAgIHJldHVybiBwcm9wcy5hcmVhID8gcHJvcHMuYXJlYSA6IFwic2hhcmVkLmFkcmVzbmlTdGl0a3lTYWJsb25hXCI7XG59XG5cbmNsYXNzIFR5cE9iYWxreUZpZWxkIGV4dGVuZHMgQWJzdHJhY3RSZWFjdENvbXBvbmVudCB7XG5cbiAgICBjb25zdHJ1Y3Rvcihwcm9wcykge1xuICAgICAgICBzdXBlcihwcm9wcyk7XG4gICAgfVxuXG4gICAgY29tcG9uZW50V2lsbE1vdW50KCkge1xuICAgICAgICBjb25zdCBhcmVhID0gZ2V0QXJlYSh0aGlzLnByb3BzKTtcbiAgICAgICAgdGhpcy5kaXNwYXRjaChvYmFsa3lBY3Rpb25zLmZldGNoTGlzdElmTmVlZGVkKGFyZWEpKTtcbiAgICB9XG5cbiAgICBzdGF0aWMgUHJvcFR5cGVzID0ge1xuICAgICAgICBzYWJsb255OiBSZWFjdC5Qcm9wVHlwZXMub2JqZWN0LCAvLyBuZW7DrSByZXF1aXJlZCBrdsWvbGkgc2hhcmVkIHN0b3JlLCBrdGVyw70gbmVtdXPDrSBiw710IGluaWNpYWxpem92YW7DvVxuICAgICAgICBhcmVhOiBSZWFjdC5Qcm9wVHlwZXMuc3RyaW5nLFxuICAgICAgICBhZGRvbnNCZWZvcmU6IENPTVBPTkVOVF9DSElMRFJFTixcbiAgICAgICAgYWRkb25zQWZ0ZXI6IENPTVBPTkVOVF9DSElMRFJFTixcbiAgICB9O1xuXG4gICAgaGFuZGxlRmlsdGVyU3VnZ2VzdGlvbnMgPSAodmFsdWUpID0+IHtcbiAgICAgICAgY29uc3Qge3NhYmxvbnl9ID0gdGhpcy5wcm9wcztcblxuICAgICAgICByZXR1cm4gbmV3IFByb21pc2UoKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgICAgICAgICAgaWYgKHNhYmxvbnkuZmV0Y2hlZCkge1xuICAgICAgICAgICAgICAgIGNvbnN0IHJvd3MgPSBmaWx0ZXJPYmplY3RzQnlQcm9wZXJ0eUZ1bGx0ZXh0KHNhYmxvbnkucm93cywgdmFsdWUsIFwicG9waXNcIik7XG4gICAgICAgICAgICAgICAgcmVzb2x2ZShyb3dzKTtcbiAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgICAgcmVzb2x2ZShbXSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH0pO1xuICAgIH07XG5cbiAgICByZW5kZXIoKSB7XG4gICAgICAgIGNvbnN0IHtzYWJsb255LCAuLi5vdGhlcn0gPSB0aGlzLnByb3BzO1xuXG4gICAgICAgIGlmICghc2FibG9ueSB8fCAhc2FibG9ueS5mZXRjaGVkKSB7XG4gICAgICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgICAgIDxJbnB1dCB0eXBlPVwidGV4dFwiIGRpc2FibGVkPXt0cnVlfSAvPlxuICAgICAgICAgICAgKVxuICAgICAgICB9XG5cbiAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICAgIDxBcGlPYmplY3RTdWdnZXN0RmllbGRcbiAgICAgICAgICAgICAgICBkcm9wZG93bj17dHJ1ZX1cbiAgICAgICAgICAgICAgICBmaWx0ZXJTdWdnZXN0aW9ucz17dGhpcy5oYW5kbGVGaWx0ZXJTdWdnZXN0aW9uc31cbiAgICAgICAgICAgICAgICBhcGlSZXF1ZXN0RGVsYXk9ezB9XG4gICAgICAgICAgICAgICAgZ2V0SXRlbVZhbHVlPXsoaXRlbSkgPT4gaXRlbSA/IGl0ZW0ucG9waXMgOiBcIlwifVxuICAgICAgICAgICAgICAgIHJlbmRlclN1Z2dlc3Rpb249eyhpLCBhY3RpdmUsIGdldEl0ZW1WYWx1ZSkgPT4gPGRpdlxuICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9e2FjdGl2ZSA/IFwiYWN0aXZlXCIgOiBcIlwifT57aS5wb3Bpc308L2Rpdj59XG4gICAgICAgICAgICAgICAgey4uLm90aGVyfVxuICAgICAgICAgICAgLz5cbiAgICAgICAgKVxuICAgIH1cbn1cblxuZnVuY3Rpb24gbWFwU3RhdGVUb1Byb3BzKHN0YXRlLCBwcm9wcykge1xuICAgIGNvbnN0IHVzZUFyZWEgPSBnZXRBcmVhKHByb3BzKTtcblxuICAgIHJldHVybiB7XG4gICAgICAgIHNhYmxvbnk6IHN0b3JlRnJvbUFyZWEoc3RhdGUsIHVzZUFyZWEsIGZhbHNlKVxuICAgIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNvbm5lY3QobWFwU3RhdGVUb1Byb3BzKShUeXBPYmFsa3lGaWVsZCk7XG4iXX0=